import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetTeamMembers, HttpGetTeamMembersOptions, HttpGetTeamMembersResponse} from '../http/teams.http'
import {QUERY_KEYS} from '@/queryClient'

export const useGetTeamMembers = (
    params: HttpGetTeamMembersOptions,
    options?: Omit<UseQueryOptions<HttpGetTeamMembersResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.TEAM_MEMBERS, params],
        queryFn: () => httpGetTeamMembers(params),
        ...options
    })
}
